<template>
    <div class="orgCourseTemplate">
        <div class="orgreleasecourse">
            <IndexHeader />
            <div class="releasecourseBoxSgl">
                <form class="el-form el-form--label-left">
                    <div class="header clear">
                        <div class="title">{{query.listType == 1 ? "考核要求":"直播信息"}}</div>
                    </div>
                    <div class="line"></div>
                    <div class="onlineTwo">
                        <div class="uploadText">
                        </div>
                        <div class="SGscheduleBox">
                            <div class="el-form-item">
                                <label class="el-form-item__label" style="width: 80px;">章节：</label>
                                <div class="el-form-item__content">
                                    <div class="scheduleTop">
                                        <div class="top">部分</div>
                                        <div class="top">小节类型</div>
                                        <div class="top">视频文件/直播间</div>
                                        <div class="top">时长</div>
                                        <div class="top">主讲人</div>
                                        <div class="top">分类</div>
                                        <div class="top">操作</div>
                                    </div>
                                    <div class="scheduleContent">
                                        <div class="scheduleItem" v-for="(item,idx) in data.schedules" :key="idx">
                                            <div class="selectDate">
                                                <div class="el-form-item">
                                                    <div class="el-form-item__content"><span class="numberCourse">
                                                            {{ courseScheduleIndex(idx) }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="rightBox clear" v-for="iitem in item" :key="iitem">
                                                <div class="selectTime">
                                                    <div class="mode">{{ iitem.videoType == 0? '录播':'直播' }}</div>
                                                </div>
                                                <div class="mode mode2">
                                                    <span>{{ iitem.name }}</span>
                                                </div>
                                                <div class="special">
                                                    <span rows="2" >
                                                        <span>{{ iitem.duration }}</span>
                                                    </span>
                                                </div>
                                                <div class="speaker clear">
                                                    <div class="alreadyTeacher">
                                                        <div class="clear iitemTeacher">
                                                            <span class="iitem" v-for="(iiitem,idx) in iitem.lecturerArr" :key="idx">{{ idx == 0? '':',' }}{{ iiitem.name }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="classification clear">
                                                    {{ iitem.classType }}
                                                </div>
                                                <div class="operation">
                                                    <el-button v-if="query.listType != 1" @click="handleLive(iitem.id)" type="text">{{ iitem.videoType == 0? '':'直播链接' }}</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="orgTest">
                            <div class="SGscheduleBox">
                                <div class="el-form-item">
                                    <label class="el-form-item__label" style="width: 80px;">考核方式：</label>
                                    <div class="el-form-item__content">
                                        <div class="scheduleTop">
                                            <div class="top" style="margin-right: 95px;">考试内容</div>
                                            <div class="top">考核分数（分）</div>
                                            <div class="top">考核说明</div>
                                        </div>
                                        <div class="orgTestContent">
                                            <div class="TestOne" v-for="item in data.assessment" :key="item">
                                                <div class="textBox" style="background: rgb(243, 248, 253);">
                                                    <label :class="item.active? 'el-checkbox is-disabled is-checked':'el-checkbox is-disabled'">
                                                        <span :class="item.active? 'el-checkbox__input is-disabled is-checked':'el-checkbox__input is-disabled'">
                                                            <span class="el-checkbox__inner"></span>
                                                            <input type="checkbox" aria-hidden="false" disabled="disabled" class="el-checkbox__original" value="">
                                                        </span>
                                                            <span class="el-checkbox__label">{{ item.title }}</span>
                                                        </label>
                                                    </div>
                                                <div class="textBox">{{ item.credit}}</div>
                                                <div class="textDetails">{{item.info}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
            <!-- 添加或修改课程直播管理对话框 -->
    <el-dialog :title="title" v-model="open" width="500px" append-to-body>
      <el-form :model="liveData" label-width="80px">
        <div>
          <el-form-item label="主讲">{{liveData.speakerShowInfo[0].url}}</el-form-item>
          <el-form-item label="频道号" prop="url">{{liveData.speakerShowInfo[0].channelId}}</el-form-item>
          <el-form-item label="密码" prop="url">{{liveData.speakerShowInfo[0].password}}</el-form-item>

          <el-form-item label="助教" prop="url">{{liveData.roleShowInfo[0].url}}</el-form-item>
          <el-form-item label="频道号" prop="url">{{liveData.roleShowInfo[0].channelId}}</el-form-item>
          <el-form-item label="密码" prop="url">{{liveData.roleShowInfo[0].password}}</el-form-item>
        </div>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="cancel">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    </div>
</template>
<script setup>
import IndexHeader from "../../components/IndexHeader/TopBar";
import { ref, reactive } from "vue";
import { useRoute,useRouter } from "vue-router";
import { khyq ,getHandleLive} from '../../server/jigou/course'
import { fa } from "element-plus/es/locale";

const route = useRoute()
const query =reactive({
  id: route.query.id,
  listType:route.query.listType,
})
const data = reactive({
    assessment: [],
    schedules: []
})
//创建直播数据
const liveData = reactive({
    speakerShowInfo: [],
    roleShowInfo: []
})
const open = ref(false)
const title = ref("直播信息");

async function getList(){
  let res = await khyq(query.id)
  console.log(res);
  if( res != false ){
    data.assessment = res.data.assessment
    data.schedules = res.data.schedules
  }
}
getList()
async function handleLive(id){
  let res = await getHandleLive(id)
  if( res != false ){
    if (res.speakerShowInfo != null) {
        liveData.speakerShowInfo = res.speakerShowInfo;
        liveData.roleShowInfo = res.roleShowInfo;
        open.value = true;   
    }
  }
}
// 取消按钮
function cancel() {
  open.value = false
}
const chineseNumbers = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
];
const courseScheduleIndex = (number) => {
  var str = "";
  if (number > 9) {
    number -= 10;
    str = "十";
  }
  str += chineseNumbers[number];
  return "第" + str + "讲";
}
</script>
<style>
    .timeSame{
        padding-top: 20px;
    }
    .textDetails{
        padding-left: 20px;
    }
    .orgreleasecourse .releasecourseBoxSgl .orgTestContent .TestOne .textDetails{
        width: 757px;
    }
    .alreadyTeacher,.classification,.mode,.operation{
        display: flex;justify-content: center;align-items: center;
    }
</style>